import React from "react"
import Grid from '@material-ui/core/Grid';

/* importing custom modules */
import StaticExpander from '../components/Material-UI-Components/StaticExpander.js';
import Layout from '../components/layout'
import SEO from "../components/seo"
import ContactForm from '../components/Custom Modules/ContactForm';

/* importing json files */
import TrainingWorkshopData from '../components/Page-Data/Training-Working.json';

/* importing images */
import Logo from '../images/Training/logo.png';

const TrainingWorkshop = () => (
  <Layout>
    <SEO 
      title="Best Training Workshop in India, Corporate and school Training workshop in India at Pratiiti.com" 
      description = "Training Workshop in India-Pratiiti.com provide you qualified trainer for Training Workshop at affordable rates."
      canonical={"https://www.pratiiti.in/training-workshop"}
    />
    <div>
    <Grid xs={12} md={6} sm={3}>
      <div className="logo">
        <img src={Logo} alt="Training & Workshop"/>
      </div>
    </Grid>
      <StaticExpander
        data = {TrainingWorkshopData}
      />
	  </div>
    <ContactForm/>
  </Layout>
)

export default TrainingWorkshop
